import { createSlice } from "@reduxjs/toolkit";
import ArsivHareketleriAramaKriterleri from "src/models/PatolojiModul/ArsivHareketleriAramaKriterleri";
import VwHbsArsivhareketDTO from "src/models/PatolojiModul/VwHbsArsivhareketDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IPatolojiArsivHareketleri {
    searchHandler: boolean;
    aramaKriterleri: ArsivHareketleriAramaKriterleri;
    open: boolean;
    activeRow: VwHbsArsivhareketDTO;
};

export const PatolojiArsivHareketleriSlice = createSlice<IPatolojiArsivHareketleri, MapReducerPayloads<IPatolojiArsivHareketleri, {
    setSearchHandler: boolean;
    setAramaKriterleri: ArsivHareketleriAramaKriterleri;
    setOpen: boolean;
    setActiveRow: VwHbsArsivhareketDTO;
}>>({
    name: "patolojiArsivHareketleri",
    initialState: {
        searchHandler: true,
        aramaKriterleri: new ArsivHareketleriAramaKriterleri(),
        open: false,
        activeRow: new VwHbsArsivhareketDTO(),
    },
    reducers: {
        //Arama kriterlerini doldurduktan sonra api ye gidip veriyi çektiği state
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload
        },
        //Arama kriterlerinin tutulduğu state
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        //İlgili row detayının bilgilerinin tutulduğu state
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        //İlgili arşiv hareket kaydının detay bilgilerinin bulunduğu dialog penceresinin statesi
        setOpen: (state, action) => {
            state.open = action.payload
        }
    }
});